import { render } from "./EditProductDialog.vue?vue&type=template&id=86f6ec0e&scoped=true"
import script from "./EditProductDialog.vue?vue&type=script&lang=js"
export * from "./EditProductDialog.vue?vue&type=script&lang=js"

import "./EditProductDialog.vue?vue&type=style&index=0&id=86f6ec0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f6ec0e"]])

export default __exports__